import "./divider.scss"; // Importing the CSS module for styling the Divider component

interface IDivider {
  label?: string | JSX.Element; // Optional label to display inside the Divider, can be a string or JSX element
}

/**
 * Divider component used for displaying a separator with an optional label.
 *
 * @param {IDivider} props - The properties object for the Divider component.
 * @param {string | JSX.Element} [props.label="OR"] - Optional label to be displayed in the Divider. Defaults to "OR".
 *
 * @returns {JSX.Element} The rendered Divider component with the specified label.
 */
export const Divider = ({ label = "OR" }: IDivider) => {
  return (
    <div className="divider-wrapper">
      {/* Render the Divider component with the provided or default label */}
      <span>{label}</span>
    </div>
  );
};
